// iter137 — Phase 3 reusable floating-label input. Drop-in replacement for
// the shadcn `Input` on auth forms (Login + Register). When the field is
// focused OR has a value, the label shrinks and floats above the input —
// classic Material-style ergonomics that signal touch readiness on mobile.
// Larger touch target (h-12) so it's comfortable for older teachers.
import { forwardRef, useId } from "react";

const FloatingLabelInput = forwardRef(function FloatingLabelInput(
  { label, value, onChange, type = "text", id, error, hint, testid, ...rest },
  ref,
) {
  const autoId = useId();
  const fieldId = id || `fli-${autoId}`;
  const hasValue = value !== undefined && value !== null && String(value).length > 0;
  return (
    <div className="floating-label-wrap">
      <input
        ref={ref}
        id={fieldId}
        type={type}
        value={value ?? ""}
        onChange={onChange}
        data-testid={testid}
        placeholder=" "
        className={`peer h-12 w-full rounded-xl border bg-white px-3 pt-4 pb-1 text-sm font-medium text-slate-900 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-brand-500/40 ${
          error ? "border-rose-400 focus:border-rose-500" : "border-slate-300 focus:border-brand-500"
        }`}
        {...rest}
      />
      <label
        htmlFor={fieldId}
        className={`pointer-events-none absolute left-3 origin-left transition-all duration-150 ${
          hasValue
            ? "top-1 text-[10px] font-bold uppercase tracking-wider text-brand-600"
            : "top-1/2 -translate-y-1/2 text-sm text-slate-500"
        } peer-focus:top-1 peer-focus:-translate-y-0 peer-focus:text-[10px] peer-focus:font-bold peer-focus:uppercase peer-focus:tracking-wider peer-focus:text-brand-600`}
      >
        {label}
      </label>
      {(hint || error) && (
        <p className={`mt-1 text-[11px] ${error ? "text-rose-600" : "text-slate-500"}`}>
          {error || hint}
        </p>
      )}
    </div>
  );
});

export default FloatingLabelInput;
